"use client";

import React from "react";
import Link from "next/link";

const BenefitsOfAllOn6: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Benefits of All-on-6 Dental Implants
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          All-on-6 implants offer life-changing advantages for patients with
          significant tooth loss:
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>Strong Support:</strong> A secure base so your teeth
            won&apos;t slip or shift
          </li>
          <li>
            <strong>Faster Healing:</strong> Less downtime compared to placing
            individual implants
          </li>
          <li>
            <strong>Natural Appearance:</strong> Customized to match your facial
            structure and look like real teeth
          </li>
        </ul>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 pt-2">
          Preservation of Jawbone Density
        </h3>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Bone loss begins the moment teeth are lost. Without tooth roots, the
          jaw no longer receives the stimulation it needs to stay healthy.
          All-on-6 implants restore that stimulation and help prevent the
          sunken facial appearance many long-term denture wearers develop.
        </p>

        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 pt-2">
          Long-Term Cost Efficiency
        </h3>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          The upfront investment is higher than dentures. Over time, however,{" "}
          <Link
            href="/blog/how-long-do-all-on-6-implants-last/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            implants can last decades
          </Link>
          , eliminating the ongoing costs of adhesives, relining, and
          replacements.
        </p>
      </div>
    </section>
  );
};

export default BenefitsOfAllOn6;
